import {
    formatCreatedDate,
    formatDateOnly,
    formatDateTime,
    formatShortDate,
    formatTimeOfDay
} from '../../../../utils/dates';
import type { DetailFormatters } from './iteroBrowseFormat';

export const BROWSE_FORMATTERS: DetailFormatters = {
    dateTime: formatDateTime,
    dateOnly: formatDateOnly,
    date: (value) => formatCreatedDate(value ?? undefined),
    time: formatTimeOfDay,
    shortDate: formatShortDate
};
